<div class="form-group">
    <table class="full-height">
      <td class="full-height dialog-column">
        <h2 mat-dialog-title>Projekt</h2>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Projektname</mat-label>
            <input matInput [formControl]="projectName" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte Projektnamen eingeben</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Strasse und Hausnummer</mat-label>
            <input matInput [formControl]="chargingStationAddressLine1" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte Strasse und Hausnummer eingeben</mat-error>
          </mat-form-field>
        </p>
        <table class="full-width">
          <tr>
            <td>
              <mat-form-field class="width-5em">
                <mat-label>PLZ</mat-label>
                <input matInput [formControl]="chargingStationPostalCode" required readonly={{isReadonly}}>
                <mat-error *ngIf="projectName.invalid">Bitte Postleitzahl eingeben</mat-error>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field class="width-8em">
                <mat-label>Stadt</mat-label>
                <input matInput [formControl]="chargingStationCity" required readonly={{isReadonly}}>
                <mat-error *ngIf="projectName.invalid">Bitte Stadt eingeben</mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
        <div id="from-group-spacer"></div>
        <h2 mat-dialog-title>Ansprechpartner</h2>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Vorname</mat-label>
            <input matInput [formControl]="projectContactFirstName" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte Vornamen eingeben</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Nachname</mat-label>
            <input matInput [formControl]="projectContactLastName" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte Nachnamen eingeben</mat-error>
          </mat-form-field>
        </p>
      </td>
      <td id="from-column-spacer"></td>
      <td>
        <h2 mat-dialog-title>Auftraggeber</h2>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Firma</mat-label>
            <input matInput [formControl]="customerCompany" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte Firmennamen eingeben</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Strasse und Hausnummer</mat-label>
            <input matInput [formControl]="customerAddressLine1" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte Strasse und Hausnummer eingeben</mat-error>
          </mat-form-field>
        </p>
        <table class="full-width">
          <tr>
            <td>
              <mat-form-field class="width-5em">
                <mat-label>PLZ</mat-label>
                <input matInput [formControl]="customerPostalCode" required readonly={{isReadonly}}>
                <mat-error *ngIf="projectName.invalid">Bitte Postleitzahl eingeben</mat-error>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field class="width-8em">
                <mat-label>Stadt</mat-label>
                <input matInput [formControl]="customerCity" required readonly={{isReadonly}}>
                <mat-error *ngIf="projectName.invalid">Bitte Stadt eingeben</mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Vorname</mat-label>
            <input matInput [formControl]="customerContactFirstName" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte geben sie den Vornamen des Auftraggebers ein</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Nachname</mat-label>
            <input matInput [formControl]="customerContactLastName" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte geben sie den Nachnamen des Auftraggebers ein</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Email</mat-label>
            <input matInput [formControl]="customerContactEmail" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte geben sie eine gültige Emailadresse ein</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="full-width">
            <mat-label>Telefonnummer</mat-label>
            <input matInput [formControl]="customerContactPhoneNumber" required readonly={{isReadonly}}>
            <mat-error *ngIf="projectName.invalid">Bitte Telefonnummer eingeben</mat-error>
          </mat-form-field>
        </p>
      </td>
    </table>
</div>
